module.exports = __webpack_public_path__ + "img/icon_e22.b1ae8c0f.png";